<template>
  <div id="app" class="min-h-screen bg-gray-50">
    <!-- 路由视图 -->
    <router-view />
  </div>
</template>

<script setup lang="ts">
import { useDocumentMeta } from '@composables/useDocumentMeta'

const { initDocumentMeta } = useDocumentMeta()

onMounted(() => {
  // 初始化文档元信息（标题和 favicon）
  initDocumentMeta()

  // 应用初始化完成日志
  console.log('[TP_APP] CargoWare X 应用组件挂载完成')
})
</script>

<style>
/* 全局样式重置 */
#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* 滚动条样式 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 高亮样式 */
.highlight {
  background-color: #fff3cd;
  color: #856404;
  padding: 0 2px;
  border-radius: 2px;
}

/* 暗色主题适配 */
[data-theme="dark"] {
  color-scheme: dark;
}

[data-theme="dark"] #app {
  background-color: #141414;
  color: #ffffff;
}

[data-theme="dark"] ::-webkit-scrollbar-track {
  background: #2f2f2f;
}

[data-theme="dark"] ::-webkit-scrollbar-thumb {
  background: #555555;
}

[data-theme="dark"] ::-webkit-scrollbar-thumb:hover {
  background: #777777;
}
</style>
